(function () {
  'use strict';
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var seg = function (p, a, b) { return clamp((p - a) / (b - a), 0, 1); };
  var easeIO = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
  var wait = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };
  var M = window.Motion;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(pointer: fine)').matches;
  var euro = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' });
  var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var spring = function (stiffness, damping, extra) {
    var o = { type: 'spring', stiffness: stiffness, damping: damping };
    for (var k in extra) o[k] = extra[k];
    return o;
  };
  var pop = function (el, kf, opt) { if (M && !reduce) return M.animate(el, kf, opt); return null; };

  // Menú móvil
  var burger = document.querySelector('.burger');
  var nav = document.getElementById('nav');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('menu-open', open);
    });
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        nav.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('menu-open');
      });
    });
  }

  // Miniaturas de producto
  var main = document.querySelector('.product__main img');
  document.querySelectorAll('.thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      if (main) { main.src = t.dataset.src; main.removeAttribute('srcset'); }
    });
  });

  // Carrito: obliga a marcar el consentimiento antes de pagar
  var form = document.getElementById('cart-form');
  var consent = document.getElementById('consent');
  if (form && consent) {
    form.addEventListener('submit', function (e) {
      if (!consent.checked) {
        e.preventDefault();
        consent.closest('.consent').classList.add('is-error');
        consent.focus();
      }
    });
    consent.addEventListener('change', function () {
      consent.closest('.consent').classList.remove('is-error');
    });
  }

  // Cabecera: se esconde al bajar y vuelve al subir
  var header = document.querySelector('.header');
  var lastY = window.scrollY;
  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    if (header && !document.body.classList.contains('menu-open')) {
      header.classList.toggle('is-hidden', y > lastY && y > 240);
    }
    lastY = y;
  }, { passive: true });

  // Barra de compra flotante: aparece al pasar la portada y se va al llegar al pie
  var buybar = document.querySelector('.buybar');
  if (buybar) {
    var heroEl = document.querySelector('.hero');
    var footEl = document.querySelector('.footer');
    var ownBuy = $$('.explode, [data-builder], .cta');
    var visible = function (el) { var r = el.getBoundingClientRect(); return r.top < window.innerHeight && r.bottom > 0; };
    var toggleBar = function () {
      var past = heroEl ? heroEl.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
      var end = footEl ? footEl.getBoundingClientRect().top < window.innerHeight : false;
      var busy = ownBuy.some(visible);
      buybar.classList.toggle('is-shown', past && !end && !busy);
    };
    window.addEventListener('scroll', toggleBar, { passive: true });
    toggleBar();
  }

  // Añadir al carrito varios productos a la vez (configurador)
  var addToCart = function (items, root, onError) {
    if (root.hasAttribute('data-preview')) { onError('Vista previa: en tu tienda este botón añade los productos al carrito.'); return; }
    fetch(shopRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      window.location.href = shopRoot + 'cart';
    }).catch(function () { onError('No se pudo añadir al carrito. Recarga la página y vuelve a intentarlo.'); });
  };

  // Configurador: elige categorías y compara con el pack
  $$('[data-builder]').forEach(function (root) {
    var picks = $$('.pick', root);
    var packPrice = parseInt(root.getAttribute('data-pack-price'), 10) || 0;
    var packVariant = root.getAttribute('data-pack-variant');
    var q = function (s) { return root.querySelector(s); };
    var totalEl = q('[data-total]'), subEl = q('[data-sub]'), msgEl = q('[data-msg]');
    var barS = q('[data-bar="sueltas"]'), barP = q('[data-bar="pack"]'), valS = q('[data-val="sueltas"]'), valP = q('[data-val="pack"]');
    var mainBtn = q('[data-main]'), altBtn = q('[data-alt]');
    var allSum = picks.reduce(function (a, p) { return a + (+p.getAttribute('data-price')); }, 0);
    var max = Math.max(allSum, packPrice) || 1;
    var shown = null, mode = 'singles', counter = null;
    if (valP) valP.textContent = euro.format(packPrice / 100);
    var setTotal = function (cents) {
      if (counter) counter.stop();
      if (M && !reduce && shown !== null) {
        counter = M.animate(shown, cents, { duration: 0.6, ease: [0.16, 1, 0.3, 1], onUpdate: function (v) { totalEl.textContent = euro.format(v / 100); } });
      } else { totalEl.textContent = euro.format(cents / 100); }
      shown = cents;
    };
    var setBar = function (el, v) {
      if (!el) return;
      var s = clamp(v / max, 0, 1);
      if (M && !reduce) M.animate(el, { scaleX: s }, spring(200, 26)); else el.style.transform = 'scaleX(' + s + ')';
    };
    var selected = function () { return picks.filter(function (p) { return p.getAttribute('aria-pressed') === 'true'; }); };
    var update = function () {
      var sel = selected(), n = sel.length;
      var sum = sel.reduce(function (a, p) { return a + (+p.getAttribute('data-price')); }, 0);
      setTotal(sum);
      setBar(barS, sum); setBar(barP, packPrice);
      valS.textContent = euro.format(sum / 100);
      subEl.textContent = n === 1 ? '1 guía suelta' : n + ' guías sueltas';
      msgEl.classList.remove('is-pack');
      altBtn.hidden = true; mainBtn.disabled = false;
      if (n === 0) {
        mode = 'none'; mainBtn.disabled = true;
        msgEl.textContent = 'Elige al menos una categoría para ver el precio.';
        mainBtn.firstChild.textContent = 'Añadir al carrito ';
      } else if (sum < packPrice || !packVariant) {
        mode = 'singles';
        msgEl.textContent = n === 1 ? 'Con una sola categoría te sale mejor la guía suelta.' : 'Con ' + n + ' categorías te salen mejor las guías sueltas.';
        mainBtn.firstChild.textContent = 'Añadir ' + (n === 1 ? '1 guía' : n + ' guías') + ' · ' + euro.format(sum / 100) + ' ';
      } else {
        mode = 'pack';
        var extra = picks.length - n;
        msgEl.classList.add('is-pack');
        msgEl.textContent = 'El pack de las ' + picks.length + ' te sale más barato: ' + euro.format(packPrice / 100) + ' en vez de ' + euro.format(sum / 100) + (extra > 0 ? ', y te llevas ' + (extra === 1 ? '1 categoría más.' : extra + ' categorías más.') : '.');
        mainBtn.firstChild.textContent = 'Añadir el pack · ' + euro.format(packPrice / 100) + ' ';
        altBtn.hidden = false;
        altBtn.textContent = 'Prefiero solo estas ' + n;
      }
      pop(msgEl, { opacity: [0.4, 1], y: [6, 0] }, spring(300, 26));
    };
    picks.forEach(function (p) {
      p.addEventListener('click', function () {
        p.setAttribute('aria-pressed', p.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        pop(p, { scale: [0.95, 1] }, spring(500, 18));
        update();
      });
    });
    var fail = function (text) { msgEl.classList.remove('is-pack'); msgEl.textContent = text; };
    var singles = function () { return selected().map(function (p) { return { id: +p.getAttribute('data-variant'), quantity: 1 }; }); };
    mainBtn.addEventListener('click', function () {
      if (mode === 'pack') addToCart([{ id: +packVariant, quantity: 1 }], root, fail);
      else if (mode === 'singles') addToCart(singles(), root, fail);
    });
    altBtn.addEventListener('click', function () { addToCart(singles(), root, fail); });
    update();
  });

  // Calculadora de margen
  $$('[data-calc]').forEach(function (root) {
    var get = function (n) { return root.querySelector('[name="' + n + '"]'); };
    var out = function (k) { return root.querySelector('[data-out="' + k + '"]'); };
    var cost = get('coste'), sell = get('venta'), units = get('unidades');
    var split = root.querySelector('.calc__split i');
    var paint = function (r) { r.style.setProperty('--p', ((r.value - r.min) / (r.max - r.min) * 100) + '%'); };
    var update = function () {
      [cost, sell, units].forEach(paint);
      var c = +cost.value, s = +sell.value, u = +units.value, m = s - c;
      out('coste').textContent = euro.format(c);
      out('venta').textContent = euro.format(s);
      out('unidades').textContent = u;
      out('margen').textContent = euro.format(m);
      out('pct').textContent = (s > 0 ? Math.round(m / s * 100) : 0) + ' %';
      out('mes').textContent = euro.format(m * u);
      root.classList.toggle('is-loss', m < 0);
      if (split) split.style.width = clamp(c / Math.max(s, c, 1) * 100, 0, 100) + '%';
    };
    [cost, sell, units].forEach(function (r) { r.addEventListener('input', update); });
    update();
  });

  // Ficha de cada guía: al pulsar una portada del abanico, la portada vuela y se abre a pantalla completa
  (function () {
    var fanEl = document.querySelector('.fan');
    var dataEl = document.querySelector('[data-fan-data]');
    if (!fanEl || !dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var guides = (data && data.guides) || [];
    var cards = $$('.fan__card', fanEl);
    if (!guides.length || cards.length < guides.length) return;
    var preview = dataEl.hasAttribute('data-preview');
    var motionOK = !!(M && !reduce);
    var ico = function (d) { return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>'; };

    var ficha = document.createElement('div');
    ficha.className = 'ficha';
    ficha.hidden = true;
    ficha.setAttribute('role', 'dialog');
    ficha.setAttribute('aria-modal', 'true');
    ficha.setAttribute('aria-labelledby', 'ficha-title');
    ficha.innerHTML =
      '<div class="ficha__backdrop" data-close></div>' +
      '<div class="ficha__top"><span class="ficha__count" data-f="count"></span>' +
        '<button type="button" class="icon-btn" data-prev aria-label="Guía anterior">' + ico('m15 18-6-6 6-6') + '</button>' +
        '<button type="button" class="icon-btn" data-next aria-label="Guía siguiente">' + ico('m9 18 6-6-6-6') + '</button>' +
        '<button type="button" class="icon-btn" data-close data-close-btn aria-label="Cerrar">' + ico('M18 6 6 18M6 6l12 12') + '</button></div>' +
      '<div class="ficha__panel">' +
        '<div class="ficha__cover"><img alt="" data-f="img"></div>' +
        '<div class="ficha__body">' +
          '<span class="eyebrow" data-f="eyebrow">Guía en PDF · Descarga inmediata</span>' +
          '<h2 class="ficha__title" id="ficha-title" data-f="title"></h2>' +
          '<div class="ficha__desc" data-f="desc"></div>' +
          '<div class="ficha__minis" data-f="minis" hidden></div>' +
          '<div class="ficha__buy"><div class="ficha__price" data-f="price"></div>' +
            '<form method="post" data-f="form"><input type="hidden" name="id" data-f="variant"><input type="hidden" name="quantity" value="1">' +
            '<button type="submit" class="btn btn--accent btn--lg">Añadir al carrito <span class="arrow" aria-hidden="true">→</span></button></form></div>' +
          '<p class="ficha__note" data-f="note" hidden></p>' +
          '<div class="ficha__links"><a data-f="url">Ver la página de la guía →</a><a href="#pack" data-f="pack"></a></div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(ficha);

    var f = function (k) { return ficha.querySelector('[data-f="' + k + '"]'); };
    var cover = ficha.querySelector('.ficha__cover');
    var backdrop = ficha.querySelector('.ficha__backdrop');
    var topBar = ficha.querySelector('.ficha__top');
    var panel = ficha.querySelector('.ficha__panel');
    var closeBtn = ficha.querySelector('[data-close-btn]');
    var formEl = f('form');
    formEl.action = shopRoot + 'cart/add';
    var idx = -1, open = false, closing = false, pushed = false, lastFocus = null, afterClose = null, byKeyboard = false;
    var bodyKids = function () { return Array.prototype.slice.call(ficha.querySelector('.ficha__body').children).filter(function (k) { return !k.hidden; }); };
    // El pack completo funciona como una ficha más (#guia-pack), con su foto de las 8 guías
    var pk0 = data.pack || {};
    var packItem = pk0.cover ? { slug: 'pack', isPack: true, cover: pk0.cover, title: pk0.title || 'Pack completo', price: pk0.price, compare: pk0.compare, save: pk0.save, variant: pk0.variant, available: pk0.available !== false, url: pk0.url, html: pk0.html } : null;
    var items = packItem ? guides.concat([packItem]) : guides;
    var nameOf = function (g) { var s = (g.title || '').replace(/^Proveedores de /i, ''); return s.charAt(0).toUpperCase() + s.slice(1); };
    f('minis').innerHTML = guides.map(function (g, i) {
      return '<button type="button" class="mini" data-mini="' + i + '"><span class="mini__img"><img src="' + g.cover + '" alt=""></span><b>' + nameOf(g) + '</b></button>';
    }).join('');
    var findSlug = function (slug) { for (var i = 0; i < items.length; i++) if (items[i].slug === slug) return i; return -1; };
    var hashSlug = function () { var m = /^#guia-([\w-]+)$/.exec(window.location.hash); return m ? m[1] : null; };
    var setHash = function (slug, push) {
      try {
        var url = window.location.pathname + window.location.search + '#guia-' + slug;
        if (push) { window.history.pushState({ ficha: slug }, '', url); pushed = true; }
        else window.history.replaceState({ ficha: slug }, '', url);
      } catch (e) { pushed = false; }
    };

    var fill = function (i) {
      var g = items[i];
      ficha.classList.toggle('ficha--pack', !!g.isPack);
      f('minis').hidden = !g.isPack;
      f('eyebrow').textContent = g.isPack ? 'Pack completo · ' + guides.length + ' guías en PDF' : 'Guía en PDF · Descarga inmediata';
      f('img').src = g.cover;
      f('title').textContent = g.title || '';
      f('desc').innerHTML = g.html || '';
      if (g.isPack) {
        f('price').innerHTML = g.price ? g.price + (g.compare ? ' <s>' + g.compare + '</s> <span class="save">Ahorras ' + g.save + '</span>' : '') + '<small>Pago único · los ' + guides.length + ' PDF te llegan por email</small>' : '';
      } else {
        f('price').innerHTML = g.price ? g.price + '<small>Pago único · el PDF te llega por email</small>' : '';
      }
      var canBuy = !!g.variant && g.available !== false;
      formEl.hidden = !canBuy;
      f('variant').value = g.variant || '';
      var link = f('url');
      if (g.url && !preview) { link.href = g.url; link.hidden = false; } else { link.hidden = true; }
      var pk = f('pack');
      if (!g.isPack && data.pack && data.pack.price) { pk.textContent = '¿Te interesan varias? Pack de las ' + guides.length + ' por ' + data.pack.price; pk.hidden = false; } else { pk.hidden = true; }
      if (g.isPack && link.href) link.textContent = 'Ver la página del pack →'; else link.textContent = 'Ver la página de la guía →';
      // Si el producto todavía no está en la tienda, en vez de quedarse sin botón lleva a la lista de productos
      if (!canBuy && !preview && data.pack && data.pack.all) { link.href = data.pack.all; link.textContent = 'Comprar en la tienda →'; link.hidden = false; }
      f('count').textContent = g.isPack ? '' : (i + 1) + ' / ' + guides.length;
      f('note').hidden = true;
    };

    // Dónde está y cómo está girada la portada en el abanico, para que la ficha salga de ella
    var geom = function (card) {
      var r = card.getBoundingClientRect();
      var t = window.getComputedStyle(card).transform, a = 1, b = 0;
      if (t && t !== 'none' && window.DOMMatrixReadOnly) { var mx = new DOMMatrixReadOnly(t); a = mx.a; b = mx.b; }
      return { cx: r.left + r.width / 2, cy: r.top + r.height / 2, w: card.offsetWidth * Math.hypot(a, b), rot: Math.atan2(b, a) * 180 / Math.PI };
    };
    var delta = function (g, rect) {
      return { x: g.cx - (rect.left + rect.width / 2), y: g.cy - (rect.top + rect.height / 2), s: g.w / rect.width, r: g.rot };
    };
    var makeFly = function (src, rect) {
      var fly = document.createElement('div');
      fly.className = 'ficha__fly';
      fly.style.left = rect.left + 'px'; fly.style.top = rect.top + 'px';
      fly.style.width = rect.width + 'px'; fly.style.height = rect.height + 'px';
      var img = document.createElement('img'); img.alt = ''; img.src = src;
      fly.appendChild(img);
      document.body.appendChild(fly);
      return fly;
    };

    // De dónde sale (y adónde vuelve) la ficha: la tarjeta o portada pulsada, o la que se vea en pantalla
    var src = null, srcGroup = null;
    var inViewport = function (el) { var r = el.getBoundingClientRect(); return r.width > 0 && r.bottom > 0 && r.top < window.innerHeight; };
    var groupFor = function (el) {
      if (!el) return null;
      var g = el.closest('[data-guide-group]');
      if (g) return $$('[data-guide-src]', g);
      return cards.indexOf(el) >= 0 ? cards : null;
    };
    var pickSource = function (i, prefer) {
      if (prefer) return prefer;
      var lists = $$('[data-guide-group]').map(function (g) { return $$('[data-guide-src]', g); });
      lists.push(cards);
      for (var k = 0; k < lists.length; k++) { var el = lists[k][i]; if (el && inViewport(el)) return el; }
      return null;
    };

    var openGuide = function (i, fromHistory, srcEl) {
      if (open) return;
      idx = i; fill(i);
      src = pickSource(i, srcEl); srcGroup = groupFor(src);
      lastFocus = document.activeElement;
      var kids = bodyKids();
      if (motionOK) { backdrop.style.opacity = '0'; topBar.style.opacity = '0'; kids.forEach(function (k) { k.style.opacity = '0'; }); }
      var sbw = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.paddingRight = sbw > 0 ? sbw + 'px' : '';
      document.body.classList.add('ficha-open');
      ficha.hidden = false; open = true;
      panel.scrollTop = 0;
      if (!fromHistory) setHash(items[i].slug, true);
      closeBtn.focus({ preventScroll: true });
      if (!motionOK) return;
      M.animate(backdrop, { opacity: [0, 1] }, { duration: 0.4 });
      M.animate(topBar, { opacity: [0, 1] }, { duration: 0.3, delay: 0.25 });
      M.animate(kids, { opacity: [0, 1], y: [28, 0] }, spring(200, 24, { delay: M.stagger(0.05, { startDelay: 0.15 }) }));
      if (!src) { M.animate(cover, { opacity: [0, 1], scale: [0.9, 1] }, spring(200, 24)); return; }
      var rect = cover.getBoundingClientRect();
      var d = delta(geom(src), rect);
      var fly = makeFly(items[i].cover, rect);
      cover.style.visibility = 'hidden';
      src.style.visibility = 'hidden';
      M.animate(fly, { x: [d.x, 0], y: [d.y, 0], scale: [d.s, 1], rotate: [d.r, 0] }, spring(170, 24)).then(function () {
        cover.style.visibility = '';
        fly.remove();
      });
    };

    var finish = function () {
      ficha.hidden = true; open = false; closing = false; pushed = false;
      document.body.classList.remove('ficha-open');
      document.body.style.paddingRight = '';
      cards.concat($$('[data-guide-src]')).forEach(function (c) { c.style.visibility = ''; });
      src = null; srcGroup = null;
      if (hashSlug()) { try { window.history.replaceState(null, '', window.location.pathname + window.location.search); } catch (e) {} }
      // Devuelve el foco a la portada solo si se abrió con teclado (con ratón no deja el contorno marcado)
      if (byKeyboard && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      else if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
      if (afterClose) { var fn = afterClose; afterClose = null; fn(); }
    };
    var doClose = function () {
      if (!open || closing) return;
      closing = true;
      if (!motionOK) { finish(); return; }
      M.animate(bodyKids().concat([topBar]), { opacity: 0 }, { duration: 0.15 });
      M.animate(backdrop, { opacity: 0 }, { duration: 0.4, delay: 0.05 });
      if (!src || !inViewport(src)) {
        M.animate(cover, { opacity: 0, scale: 0.9 }, { duration: 0.3 }).then(function () { cover.style.opacity = ''; cover.style.transform = ''; finish(); });
        return;
      }
      var rect = cover.getBoundingClientRect();
      var d = delta(geom(src), rect);
      var fly = makeFly(items[idx].cover, rect);
      cover.style.visibility = 'hidden';
      M.animate(fly,{ x: [0, d.x], y: [0, d.y], scale: [1, d.s], rotate: [0, d.r] }, spring(220, 28)).then(function () {
        fly.remove();
        cover.style.visibility = '';
        finish();
      });
    };
    var requestClose = function () {
      if (pushed) {
        try {
          window.history.back();
          setTimeout(function () { if (open && !closing) doClose(); }, 350);
          return;
        } catch (e) {}
      }
      doClose();
    };

    // Cambia de ficha sin cerrar (flechas, miniaturas del pack o botón "atrás")
    var switchTo = function (next, dir) {
      if (!open || closing || next === idx) return;
      if (src) src.style.visibility = '';
      src = (srcGroup && !items[next].isPack) ? srcGroup[next] || null : null;
      if (src && !inViewport(src)) src = null;
      if (motionOK && src) src.style.visibility = 'hidden';
      idx = next; fill(next);
      panel.scrollTop = 0;
      setHash(items[next].slug, false);
      if (!motionOK) return;
      M.animate(cover, { x: [dir * 70, 0], rotate: [dir * 4, 0], opacity: [0, 1] }, spring(260, 26));
      M.animate(bodyKids(), { opacity: [0, 1], x: [dir * 30, 0] }, spring(260, 26, { delay: M.stagger(0.03) }));
    };
    var go = function (dir) {
      if (!open || closing || items[idx].isPack) return;
      switchTo((idx + dir + guides.length) % guides.length, dir);
    };

    cards.forEach(function (c, i) {
      c.addEventListener('click', function (e) { byKeyboard = e.detail === 0; openGuide(i, false, c); });
    });
    ficha.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]') || e.target === panel) { requestClose(); return; }
      if (e.target.closest('[data-prev]')) { go(-1); return; }
      if (e.target.closest('[data-next]')) { go(1); return; }
      var mini = e.target.closest('[data-mini]');
      if (mini) { switchTo(+mini.getAttribute('data-mini'), 1); return; }
      if (e.target.closest('[data-f="pack"]')) {
        e.preventDefault();
        afterClose = function () { var p = document.getElementById('pack'); if (p) p.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' }); };
        requestClose();
      }
    });
    formEl.addEventListener('submit', function (e) {
      if (!preview) return;
      e.preventDefault();
      var n = f('note');
      n.textContent = items[idx] && items[idx].isPack ? 'Vista previa: en tu tienda este botón añade el pack al carrito.' : 'Vista previa: en tu tienda este botón añade la guía al carrito.';
      n.hidden = false;
    });
    document.addEventListener('keydown', function (e) {
      if (!open) return;
      if (e.key === 'Escape') { e.preventDefault(); requestClose(); }
      else if (e.key === 'ArrowRight') go(1);
      else if (e.key === 'ArrowLeft') go(-1);
      else if (e.key === 'Tab') {
        var items = $$('button, a[href], input:not([type="hidden"])', ficha).filter(function (el) { return !el.hidden && !el.closest('[hidden]') && el.offsetParent !== null; });
        if (!items.length) return;
        var first = items[0], last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    window.addEventListener('popstate', function () {
      var j = findSlug(hashSlug());
      if (open && j < 0) { pushed = false; doClose(); }
      else if (open && j >= 0 && j !== idx) { switchTo(j, j > idx ? 1 : -1); }
      else if (!open && j >= 0) openGuide(j, true);
    });
    // Cualquier enlace de esta página a "#guia-…" (menú, botones) abre esa ficha
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="#guia-"]');
      if (!a || ficha.contains(a)) return;
      var url;
      try { url = new URL(a.href, window.location.href); } catch (err) { return; }
      if (url.pathname !== window.location.pathname) return;
      var j = findSlug(url.hash.replace('#guia-', ''));
      if (j < 0) return;
      e.preventDefault();
      byKeyboard = e.detail === 0;
      var pc = a.closest('.pcard');
      var srcEl = a.hasAttribute('data-guide-src') ? a : (pc ? pc.querySelector('[data-guide-src]') : null);
      openGuide(j, false, srcEl);
    });
    // Enlace directo a una guía (por ejemplo tutienda.com/#guia-ropa)
    var start = findSlug(hashSlug());
    if (start >= 0) setTimeout(function () { openGuide(start, true); }, 500);
  })();

  // ---------- A partir de aquí, solo animaciones (Motion) ----------
  if (!M || reduce) return;
  var animate = M.animate, scroll = M.scroll, inView = M.inView, stagger = M.stagger;

  var splitWords = function (node, cls) {
    Array.prototype.slice.call(node.childNodes).forEach(function (child) {
      if (child.nodeType === 3) {
        var frag = document.createDocumentFragment();
        child.textContent.split(/(\s+)/).forEach(function (part) {
          if (!part) return;
          if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
          var s = document.createElement('span'); s.className = cls; s.textContent = part; frag.appendChild(s);
        });
        node.replaceChild(frag, child);
      } else if (child.nodeType === 1 && child.tagName.toLowerCase() !== 'svg') {
        splitWords(child, cls);
      }
    });
  };

  // Barra de progreso de lectura
  var bar = document.querySelector('.progress');
  if (bar) scroll(function (p) { bar.style.transform = 'scaleX(' + p + ')'; });

  // Portada: título palabra a palabra
  var title = document.querySelector('.hero__title');
  if (title) {
    splitWords(title, 'w');
    animate($$('.w', title), { y: ['0.6em', '0em'], rotate: [6, 0], opacity: [0, 1] }, spring(220, 22, { delay: stagger(0.05) }));
    var path = title.querySelector('.hl path');
    if (path) {
      var len = path.getTotalLength();
      path.style.strokeDasharray = len; path.style.strokeDashoffset = len;
      animate(path, { strokeDashoffset: [len, 0] }, { duration: 0.9, delay: 0.7, ease: [0.65, 0, 0.35, 1] });
    }
  }
  var heroBits = $$('.hero__text, .hero__ctas, .hero__points li');
  if (heroBits.length) animate(heroBits, { y: [24, 0], opacity: [0, 1] }, spring(200, 24, { delay: stagger(0.06, { startDelay: 0.35 }) }));

  // Portada: abanico de portadas
  var fan = document.querySelector('.fan');
  if (fan) {
    var cards = $$('.fan__card', fan);
    var n = cards.length, mid = (n - 1) / 2;
    // Posición de cada tarjeta (x/y en % de su tamaño); la destacada se levanta y las vecinas se apartan
    // Separación de cada tarjeta respecto al centro, en % de su ancho
    // Con más de 5 tarjetas, el abanico se cierra un poco (menos separación y giro) para que quepan todas
    var many = n > 5;
    var SP = many ? 24 : 34, ROT = many ? 5.5 : 9, DY = many ? 4.5 : 7, DS = many ? 0.025 : 0.04;
    var OFF = cards.map(function (c, i) { return (i - mid) * SP; });
    var pose = function (i, hot) {
      var o = i - mid, lifted = i === hot, push = hot < 0 || lifted ? 0 : (i < hot ? -7 : 7);
      return { x: OFF[i] + push, y: Math.abs(o) * DY - (lifted ? 14 : 0), r: lifted ? o * 4 : o * ROT, s: lifted ? 1.06 : 1 - Math.abs(o) * DS };
    };
    // La tarjeta de arriba del todo es la central (con número par, la de la derecha del centro)
    var topIdx = Math.floor(n / 2);
    var zBase = function (i) { return 10 - Math.abs(i - topIdx); };

    // Motor de muelles propio: sabemos en todo momento dónde está cada tarjeta, así que
    // podemos pasarla al frente con un fundido en vez de cambiar el orden de golpe.
    // Mientras dura el fundido, una copia de la tarjeta aparece poco a poco por encima.
    var K = 230, D = 23, FADE = 0.26;
    var clock = function () { return performance.now() / 1000; };
    var t0 = clock();
    var st = cards.map(function (c, i) {
      c.style.zIndex = String(zBase(i));
      return { el: c, x: 0, y: 18, r: 0, s: 0.8, vx: 0, vy: 0, vr: 0, vs: 0, t: pose(i, -1), k: 120, d: 16, wake: t0 + 0.25 + Math.abs(i - mid) * 0.08, front: 0, frontT: 0, ghost: null };
    });
    var transformOf = function (s) { return 'translate(' + s.x.toFixed(2) + '%,' + s.y.toFixed(2) + '%) rotate(' + s.r.toFixed(2) + 'deg) scale(' + s.s.toFixed(4) + ')'; };
    var smooth = function (f) { return f * f * (3 - 2 * f); };
    var makeGhost = function (s) {
      var g = s.el.cloneNode(true);
      g.classList.add('fan__ghost');
      g.setAttribute('aria-hidden', 'true');
      g.removeAttribute('aria-label');
      g.tabIndex = -1;
      fan.appendChild(g);
      return g;
    };
    var running = false, lastT = 0;
    var tick = function () {
      var t = clock(), dt = Math.min(1 / 30, Math.max(0, t - lastT)); lastT = t;
      var busy = false;
      st.forEach(function (s, i) {
        if (t >= s.wake) {
          ['x', 'y', 'r', 's'].forEach(function (p) {
            var v = 'v' + p;
            s[v] += (-s.k * (s[p] - s.t[p]) - s.d * s[v]) * dt;
            s[p] += s[v] * dt;
            if (Math.abs(s[p] - s.t[p]) > 0.005 || Math.abs(s[v]) > 0.005) busy = true;
            else { s[p] = s.t[p]; s[v] = 0; }
          });
        } else busy = true;
        if (s.front !== s.frontT) {
          var f = dt / FADE;
          s.front = s.frontT > s.front ? Math.min(s.frontT, s.front + f) : Math.max(s.frontT, s.front - f);
          busy = true;
        }
        var fading = s.front > 0 && s.front < 1;
        if (fading && !s.ghost) s.ghost = makeGhost(s);
        if (!fading && s.ghost) { s.ghost.remove(); s.ghost = null; }
        var tr = transformOf(s);
        s.el.style.transform = tr;
        s.el.style.zIndex = String(s.front >= 1 ? 20 : zBase(i));
        if (s.ghost) {
          s.ghost.style.transform = tr;
          s.ghost.style.opacity = smooth(s.front).toFixed(3);
          s.ghost.style.zIndex = s.frontT > 0 ? '22' : '21';
          s.ghost.style.visibility = s.el.style.visibility;
          s.ghost.classList.toggle('is-hot', s.el.classList.contains('is-hot'));
        }
      });
      if (busy) requestAnimationFrame(tick); else running = false;
    };
    var kick = function () { if (!running) { running = true; lastT = clock(); requestAnimationFrame(tick); } };
    kick();

    // El ratón se lee sobre el abanico entero (no sobre cada tarjeta), así una tarjeta
    // que se mueve no "roba" el ratón a su vecina y no hay parpadeos.
    var hot = -1;
    var focusCard = function (idx) {
      if (idx === hot) return;
      hot = idx;
      var t = clock();
      st.forEach(function (s, i) {
        s.t = pose(i, hot); s.k = K; s.d = D;
        if (s.wake > t) s.wake = t;
        s.frontT = i === hot ? 1 : 0;
        s.el.classList.toggle('is-hot', i === hot);
      });
      kick();
    };
    if (finePointer) {
      // Elige la tarjeta según la franja que se ve de cada una en reposo: a la izquierda del centro,
      // cada tarjeta se ve hasta donde empieza la siguiente; a la derecha, desde donde acaba la anterior.
      // Se calcula con la posición en reposo, así no cambia mientras las tarjetas se mueven.
      fan.addEventListener('pointermove', function (e) {
        var r = fan.getBoundingClientRect();
        var frac = cards[0].offsetWidth / Math.max(1, fan.offsetWidth);
        var px = (e.clientX - r.left) / r.width;
        var edge = OFF.map(function (off, i) { var c = 0.5 + off / 100 * frac, h = frac / 2 * pose(i, -1).s; return { L: c - h, R: c + h }; });
        var pick = n - 1;
        for (var k = 0; k < n - 1; k++) {
          var b = (k + 1 <= topIdx) ? edge[k + 1].L : edge[k].R;
          if (px < b) { pick = k; break; }
        }
        focusCard(pick);
      });
      fan.addEventListener('pointerleave', function () { focusCard(-1); });
    }
    var hero = document.querySelector('.hero');
    var glow = document.querySelector('.hero__glow');
    if (hero && finePointer) {
      hero.addEventListener('pointermove', function (e) {
        var r = hero.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
        animate(fan, { rotateY: (px - 0.5) * 16, rotateX: (0.5 - py) * 12 }, spring(120, 20));
        if (glow) { glow.style.setProperty('--gx', (px * 100) + '%'); glow.style.setProperty('--gy', (py * 100) + '%'); }
      });
      hero.addEventListener('pointerleave', function () { animate(fan, { rotateY: 0, rotateX: 0 }, spring(120, 20)); });
    }
  }
  // Etiquetas flotantes ("16 contactos", "PDF al momento"): entran, flotan y se apartan
  // en cuanto vas a elegir una guía, para no tapar el botón "Ver guía".
  var chips = $$('.chip');
  var chipsAway = false;
  var moveChips = function (away) {
    if (away === chipsAway) return;
    chipsAway = away;
    chips.forEach(function (chip, i) {
      var dir = chip.classList.contains('chip--a') ? -1 : 1;
      if (away) animate(chip, { x: dir * 56, rotate: dir * -6, scale: 0.82, opacity: 0, filter: 'blur(10px)' }, { duration: 0.38, ease: [0.4, 0, 0.2, 1], delay: i * 0.04 });
      else animate(chip, { x: 0, rotate: 0, scale: 1, opacity: 1, filter: 'blur(0px)' }, spring(240, 20, { delay: 0.12 + i * 0.08 }));
    });
  };
  chips.forEach(function (chip, i) {
    animate(chip, { scale: [0.6, 1], opacity: [0, 1] }, spring(260, 18, { delay: 0.9 + i * 0.15 })).then(function () {
      animate(chip, { y: [0, -10, 0] }, { duration: 4 + i, repeat: Infinity, ease: 'easeInOut' });
    });
  });
  if (fan && chips.length) {
    if (finePointer) {
      fan.addEventListener('pointerenter', function () { moveChips(true); });
      fan.addEventListener('pointerleave', function () { moveChips(false); });
    } else {
      // En móvil no hay "pasar por encima": se lucen unos segundos y luego se apartan solas
      setTimeout(function () { moveChips(true); }, 4200);
      fan.addEventListener('pointerdown', function () { moveChips(true); });
    }
  }

  // Portada: al bajar, el texto sube y el abanico se aleja
  var heroSec = document.querySelector('.hero');
  var heroCopy = document.querySelector('.hero__copy');
  var heroVis = document.querySelector('.hero__visual');
  // Solo en pantallas anchas: en móvil el texto va debajo de las portadas y se leería desvaneciéndose
  if (heroSec && heroCopy && heroVis && window.matchMedia('(min-width: 901px)').matches) {
    scroll(function (p) {
      heroCopy.style.transform = 'translate3d(0,' + (-p * 90) + 'px,0)';
      heroCopy.style.opacity = String(1 - p * 0.8);
      heroVis.style.transform = 'translate3d(0,' + (p * 70) + 'px,0) scale(' + (1 - p * 0.1) + ')';
    }, { target: heroSec, offset: ['start start', 'end start'] });
  }

  // Frase que se ilumina palabra a palabra
  $$('[data-words]').forEach(function (el) {
    splitWords(el, 'sw');
    var words = $$('.sw', el), N = words.length;
    scroll(function (p) {
      var head = p * (N + 6);
      for (var i = 0; i < N; i++) words[i].style.opacity = (0.14 + 0.86 * clamp(head - i, 0, 1)).toFixed(3);
    }, { target: el, offset: ['start 85%', 'end 45%'] });
  });

  // Pack que se despliega (escena fija mientras haces scroll)
  $$('.explode').forEach(function (sec) {
    var deck = $$('.ex-card', sec);
    if (!deck.length) return;
    var caps = deck.map(function (c) { return c.querySelector('figcaption'); });
    var titles = $$('.explode__title span', sec);
    var foot = sec.querySelector('.explode__foot');
    var list = sec.querySelector('.explode__list');
    var glowEl = sec.querySelector('.explode__glow');
    var stage = sec.querySelector('.explode__stage');
    var count = deck.length, centre = (count - 1) / 2;
    var cw = 0, spacing = 0, overlap = false, lastP = 0;
    // Si el pack es lo primero de la página, las guías se levantan solas al cargar
    // y el scroll se usa solo para abrirlas en fila.
    var atTop = (sec.getBoundingClientRect().top + window.scrollY) < window.innerHeight * 0.5;
    var intro = atTop ? 0 : 1;
    sec.classList.add('is-live');
    var measure = function () {
      cw = deck[0].offsetWidth;
      var room = stage.clientWidth - 32;
      spacing = Math.min(cw * 1.14, (room - cw) / Math.max(1, count - 1));
      overlap = spacing < cw * 0.98;
      sec.classList.toggle('is-overlap', overlap);
    };
    var render = function (p) {
      lastP = p;
      var rise = atTop ? easeIO(intro) : easeIO(seg(p, 0.02, 0.34));
      var spread = atTop ? easeIO(seg(p, 0.08, 0.6)) : easeIO(seg(p, 0.34, 0.72));
      deck.forEach(function (c, i) {
        var o = i - centre;
        var stackY = -i * 7 * (1 - spread);
        var x = o * spacing * spread;
        var y = (1 - rise) * 140 + stackY + (overlap ? Math.abs(o) * 12 * spread : 0);
        var rx = 64 * (1 - rise);
        var rz = o * 5 * rise * (1 - spread) + (overlap ? o * 7 * spread : 0);
        var sc = 1.22 - 0.22 * rise - (overlap ? Math.abs(o) * 0.04 * spread : 0);
        c.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0) rotateX(' + rx.toFixed(2) + 'deg) rotateZ(' + rz.toFixed(2) + 'deg) scale(' + sc.toFixed(3) + ')';
        c.style.zIndex = spread > 0.5 && overlap ? String(10 - Math.abs(Math.round(o))) : String(i + 1);
      });
      var capO = seg(p, 0.64, 0.8);
      caps.forEach(function (cap) { if (cap) { cap.style.opacity = capO; cap.style.transform = 'translateY(' + ((1 - capO) * 12) + 'px)'; cap.style.pointerEvents = capO > 0.6 ? 'auto' : 'none'; } });
      if (list) list.style.opacity = capO;
      if (titles.length === 3) {
        var t = [1 - seg(p, 0.24, 0.32), seg(p, 0.3, 0.38) * (1 - seg(p, 0.6, 0.68)), seg(p, 0.66, 0.74)];
        titles.forEach(function (s, i) {
          s.style.opacity = t[i];
          s.style.transform = 'translateY(' + ((1 - t[i]) * (p > (i + 0.5) / 3 ? -24 : 24)) + 'px)';
        });
      }
      if (foot) {
        var f = seg(p, 0.74, 0.86);
        foot.style.opacity = f;
        foot.style.transform = 'translateY(' + ((1 - f) * 24) + 'px)';
        foot.style.pointerEvents = f > 0.5 ? 'auto' : 'none';
      }
      if (glowEl) { glowEl.style.opacity = 0.25 + 0.75 * spread; glowEl.style.transform = 'translate(-50%,-50%) scale(' + (0.7 + 0.3 * spread) + ')'; }
    };
    measure(); render(0);
    if (atTop) {
      animate(0, 1, { duration: 1.6, delay: 0.25, ease: [0.16, 1, 0.3, 1], onUpdate: function (v) { intro = v; render(lastP); } });
      var head = sec.querySelector('.explode__head');
      if (head) animate(head, { opacity: [0, 1], y: [24, 0] }, spring(160, 22, { delay: 0.1 }));
    }
    window.addEventListener('resize', function () { measure(); render(lastP); });
    scroll(render, { target: sec, offset: ['start start', 'end end'] });
    deck.forEach(function (c) {
      var img = c.querySelector('.ex-card__img');
      c.addEventListener('pointerenter', function () { if (lastP > 0.72) animate(img, { y: -14, scale: 1.04 }, spring(320, 20)); });
      c.addEventListener('pointerleave', function () { animate(img, { y: 0, scale: 1 }, spring(260, 20)); });
    });
  });

  // Galería horizontal: bajas y las guías pasan de lado
  $$('.hs').forEach(function (sec) {
    var track = sec.querySelector('.hs__track'), vp = sec.querySelector('.hs__viewport'), sticky = sec.querySelector('.hs__sticky');
    var fill = sec.querySelector('.hs__bar i'), countEl = sec.querySelector('.hs__count');
    if (!track || !vp || !sticky) return;
    var items = Array.prototype.slice.call(track.children).filter(function (c) { return c.classList.contains('card'); });
    var dist = 0, live = false;
    var label = function (p) { if (countEl && items.length) countEl.textContent = (Math.min(items.length, Math.round(p * (items.length - 1)) + 1)) + ' / ' + items.length; };
    var setup = function () {
      var want = window.innerWidth >= 900 && items.length > 2;
      if (want !== live) {
        live = want;
        sec.classList.toggle('is-live', live);
        if (!live) { sec.style.height = ''; track.style.transform = ''; }
      }
      if (live) {
        dist = Math.max(0, track.scrollWidth - vp.clientWidth);
        sec.style.height = (sticky.offsetHeight + dist) + 'px';
      }
    };
    setup();
    window.addEventListener('resize', setup);
    scroll(function (p) {
      if (!live) return;
      track.style.transform = 'translate3d(' + (-p * dist).toFixed(1) + 'px,0,0)';
      if (fill) fill.style.transform = 'scaleX(' + p + ')';
      label(p);
    }, { target: sec, offset: ['start start', 'end end'] });
    track.addEventListener('scroll', function () {
      if (live) return;
      var p = track.scrollLeft / Math.max(1, track.scrollWidth - track.clientWidth);
      if (fill) fill.style.transform = 'scaleX(' + p + ')';
      label(p);
    }, { passive: true });
    label(0);
  });

  // Aparición al hacer scroll (el contenido siempre es legible en reposo)
  var below = function (el) { return el.getBoundingClientRect().top > window.innerHeight * 0.9; };

  // Tarjetas de proveedores: entran una a una al cargar
  var pcs = $$('.pcard');
  if (pcs.length && !below(pcs[0])) {
    animate(pcs, { y: [30, 0], opacity: [0, 1] }, spring(200, 24, { delay: stagger(0.06, { startDelay: 0.1 }) })).then(function () {
      pcs.forEach(function (el) { el.style.transform = ''; });
    });
  }
  $$('[data-reveal]').forEach(function (el) {
    if (!below(el)) return;
    el.style.opacity = '0.35'; el.style.transform = 'translateY(40px)';
    inView(el, function () { animate(el, { y: [40, 0], opacity: [0.35, 1] }, spring(160, 22)); }, { margin: '0px 0px -10% 0px' });
  });
  $$('[data-stagger]').forEach(function (group) {
    var kids = Array.prototype.slice.call(group.children).filter(function (k) { return !k.classList.contains('steps__line'); });
    if (!below(group)) return;
    kids.forEach(function (k) { k.style.opacity = '0.35'; k.style.transform = 'translateY(36px)'; });
    inView(group, function () { animate(kids, { y: [36, 0], opacity: [0.35, 1] }, spring(170, 22, { delay: stagger(0.08) })); }, { margin: '0px 0px -10% 0px' });
  });

  // Contadores: el número final está escrito en el HTML; aquí solo cuenta hasta él
  $$('[data-count]').forEach(function (el) {
    var target = parseFloat(el.getAttribute('data-count'));
    var dec = (el.getAttribute('data-count').split('.')[1] || '').length;
    inView(el, function () {
      animate(0, target, { duration: 1.6, ease: [0.16, 1, 0.3, 1], onUpdate: function (v) { el.textContent = v.toFixed(dec).replace('.', ','); } });
    });
  });

  // Tarjetas: inclinación 3D, brillo y foco que sigue al ratón
  if (finePointer) {
    $$('.card').forEach(function (card) {
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
        card.style.setProperty('--mx', (px * 100) + '%'); card.style.setProperty('--my', (py * 100) + '%');
        animate(card, { rotateX: (0.5 - py) * 8, rotateY: (px - 0.5) * 10, y: -6, transformPerspective: 900 }, spring(250, 22));
      });
      card.addEventListener('pointerleave', function () { animate(card, { rotateX: 0, rotateY: 0, y: 0 }, spring(200, 18)); });
    });
    $$('.tile').forEach(function (tile) {
      tile.addEventListener('pointermove', function (e) {
        var r = tile.getBoundingClientRect();
        tile.style.setProperty('--mx', (e.clientX - r.left) + 'px'); tile.style.setProperty('--my', (e.clientY - r.top) + 'px');
      });
    });
    $$('.btn--lg').forEach(function (btn) {
      btn.addEventListener('pointermove', function (e) {
        var r = btn.getBoundingClientRect();
        animate(btn, { x: (e.clientX - r.left - r.width / 2) * 0.18, y: (e.clientY - r.top - r.height / 2) * 0.3 }, spring(300, 18));
      });
      btn.addEventListener('pointerleave', function () { animate(btn, { x: 0, y: 0 }, spring(300, 14)); });
    });
  }
  $$('.btn, .pick').forEach(function (btn) {
    btn.addEventListener('pointerdown', function () { animate(btn, { scale: 0.96 }, spring(500, 25)); });
    ['pointerup', 'pointerleave'].forEach(function (ev) { btn.addEventListener(ev, function () { animate(btn, { scale: 1 }, spring(400, 15)); }); });
  });

  // Móvil del bento: llega el email y se descarga el PDF
  $$('.phone').forEach(function (phone) {
    var notif = phone.querySelector('.notif'), dl = phone.querySelector('.dl'), fillBar = phone.querySelector('.dl__bar i'), pct = phone.querySelector('[data-dl-pct]');
    if (!notif || !dl || !fillBar || !pct) return;
    var started = false;
    var cycle = function () {
      notif.style.opacity = '0'; dl.style.opacity = '0'; fillBar.style.transform = 'scaleX(0)'; pct.textContent = '0 %';
      wait(600).then(function () {
        return animate(notif, { y: [-50, 0], opacity: [0, 1], scale: [0.9, 1] }, spring(320, 22));
      }).then(function () { return wait(700); }).then(function () {
        return animate(dl, { y: [24, 0], opacity: [0, 1] }, spring(280, 24));
      }).then(function () {
        return animate(0, 100, { duration: 1.8, ease: 'easeInOut', onUpdate: function (v) { fillBar.style.transform = 'scaleX(' + v / 100 + ')'; pct.textContent = Math.round(v) + ' %'; } });
      }).then(function () {
        pct.textContent = 'Descargado';
        return wait(2600);
      }).then(function () {
        return animate([notif, dl], { opacity: 0, y: -12 }, { duration: 0.4 });
      }).then(cycle);
    };
    inView(phone, function () { if (!started) { started = true; cycle(); } });
  });

  // Chat del bento: la conversación se escribe sola
  $$('.chat').forEach(function (chat) {
    var bubbles = $$('.bubble', chat), typing = chat.querySelector('.typing-bubble');
    var started = false;
    var cycle = function () {
      bubbles.forEach(function (b) { b.style.display = 'none'; });
      var seq = wait(500);
      bubbles.forEach(function (b) {
        seq = seq.then(function () {
          if (!b.classList.contains('bubble--in') || !typing) return null;
          chat.insertBefore(typing, b);
          typing.style.display = 'inline-flex';
          return animate(typing, { opacity: [0, 1], scale: [0.8, 1] }, spring(400, 25))
            .then(function () { return wait(1100); })
            .then(function () { typing.style.display = 'none'; });
        }).then(function () {
          b.style.display = '';
          return animate(b, { opacity: [0, 1], y: [14, 0], scale: [0.92, 1] }, spring(380, 24));
        }).then(function () { return wait(800); });
      });
      seq.then(function () { return wait(2800); })
        .then(function () { return animate(bubbles, { opacity: 0 }, { duration: 0.35 }); })
        .then(cycle);
    };
    inView(chat, function () { if (!started) { started = true; cycle(); } });
  });

  // Pack destacado (si lo usas en otra página): la portada flota con el scroll
  var packImg = document.querySelector('.pack__img');
  var packBox = document.querySelector('.pack__box');
  if (packImg && packBox) {
    scroll(animate(packImg, { rotate: [-5, 3], y: [40, -30] }, { ease: 'linear' }), { target: packBox, offset: ['start end', 'end start'] });
  }

  // Pasos: la línea se dibuja con el scroll
  var line = document.querySelector('.steps__line i');
  var steps = document.querySelector('.steps');
  if (line && steps) {
    scroll(function (p) { line.style.transform = 'scaleX(' + p + ')'; }, { target: steps, offset: ['start 85%', 'center 45%'] });
  }

  // Vista del PDF: los contactos entran uno a uno
  var doc = document.querySelector('.doc');
  if (doc) {
    inView(doc, function () {
      animate($$('.contact', doc), { x: [-30, 0], opacity: [0.2, 1] }, spring(200, 22, { delay: stagger(0.12) }));
      var lock = doc.querySelector('.lock');
      if (lock) animate(lock, { scale: [0, 1], rotate: [-20, 0] }, spring(300, 14, { delay: 0.6 })).then(function () {
        animate(lock, { scale: [1, 1.06, 1] }, { duration: 2.2, repeat: Infinity, ease: 'easeInOut' });
      });
    });
  }

  // Preguntas: apertura suave
  $$('.faq__item').forEach(function (item) {
    var summary = item.querySelector('summary');
    var body = item.querySelector('.faq__a');
    if (!summary || !body) return;
    summary.addEventListener('click', function (e) {
      e.preventDefault();
      if (item.open) {
        animate(body, { height: [body.offsetHeight + 'px', '0px'], opacity: [1, 0] }, { duration: 0.28, ease: [0.4, 0, 0.2, 1] }).then(function () {
          item.open = false; body.style.height = ''; body.style.opacity = '';
        });
      } else {
        item.open = true;
        var h = body.offsetHeight;
        animate(body, { height: ['0px', h + 'px'], opacity: [0, 1] }, spring(260, 30)).then(function () { body.style.height = ''; });
      }
    });
  });

  // Llamada final: crece hasta su tamaño mientras llega al centro
  var cta = document.querySelector('.cta');
  if (cta) {
    scroll(function (p) {
      cta.style.transform = 'scale(' + (0.86 + 0.14 * p).toFixed(4) + ')';
      cta.style.borderRadius = (60 - 28 * p).toFixed(1) + 'px';
    }, { target: cta, offset: ['start end', 'center center'] });
  }
})();
